import { useLocalStorage } from "./useLocalStorage";
import { TEXT_LANGUAGES } from "../constants";

export const LANGUAGE_SPACE_STORAGE_KEY = "language-space";

export type LanguageSpace = "ALL" | (typeof TEXT_LANGUAGES)[number]["id"];

export function useLanguageSpace(defaultLanguage: LanguageSpace = "ENGLISH") {
  const [languageSpace, setLanguageSpace] = useLocalStorage<LanguageSpace>(
    LANGUAGE_SPACE_STORAGE_KEY,
    defaultLanguage,
  );

  return {
    languageSpace,
    setLanguageSpace,
  };
}
